app.controller('EmployeeNewOutgoingDocumentController', ['$scope', '$uibModal', 'AuthService', 'StaticData', 'DocumentsService', '$http', 'usSpinnerService', 'toastr', '$state', '$rootScope', 'Hr',
    function ($scope, $uibModal, AuthService, StaticData, DocumentsService, $http, usSpinnerService, toastr, $state, $rootScope, Hr) {
        $scope.isRoot = false;
        $scope.format = "dd-MM-yyyy";
        $scope.documentTypes = {
            'OUTGOING': []
        };
        $scope.receiverTypes = [
            { name: 'ორგანიზაცია', value: 'ORGANISATION' },
            { name: 'კერძო პირი', value: 'PERSON' }
        ];
        $scope.type = null;
        $scope.receiverType = null;
        $scope.documentAuthors = {
            'UNIT': [],
            'PERSON': []
        };
        $scope.receivers = [];
        $scope.receiver = {
            name: '',
            id: ''
        }
        $scope.senderIdInput = '';
        $scope.addresseeType = null;
        $scope.text = '';
        $scope.comment = '';
        $scope.topic = '';
        $scope.resolutionComment = '';
        $scope.addressees = [];
        $scope.addressee = [];
        $scope.attachments = [];
        $scope.infos = [];
        $scope.author = null;
        $scope.sheetsNumber = '';
        $scope.pickerPopup = { opened: false };
        $scope.action = 'create';
        $scope.isForStudent = null;
        $scope.basisFileNumber = null;
        $scope.basisFile = null;
        $scope.basisFiles = [];
        $scope.basisDocNumber = null;
        $scope.basisDocs = [];
        $scope.deadLine = null;
        $scope.dateOptions = {
            "is-open": "false",
            dateDisabled: false,
            formatYear: 'yyyy',
            startingDay: 1
        };

        $scope.enabledTiny = {
            selector: "textarea",
            plugins: 'autoresize link code table lists wordcount visualchars visualblocks nonbreaking',
            toolbar: 'compareButton undo redo | fontselect fontsizeselect | bold italic underline strikethrough forecolor backcolor | blockquote subscript superscript | alignleft aligncenter alignright alignjustify | numlist bullist| code | table | removeformat | wordcount visualchars visualblocks nonbreaking',
            fontsize_formats: '8px 10px 12px 14px 18px 24px 36px'
        };

        $scope.popup1 = {
            opened: false
        };
        $scope.open1 = function () {
            $scope.popup1.opened = true;
        };
        $scope.popupDateGenerated = {
            opened: false
        };
        $scope.openDateGeneratedPopup = function () {
            $scope.popupDateGenerated.opened = true;
        };

        AuthService.getUserData().then(function (user) {
            $scope.profile = user.profiles.filter(function (p) {
                return p.type === "employee" && p.state === 'active'
            })[0];

            if ($scope.profile.positionInfo) {
                AuthService.isRoot = $scope.profile.positionInfo.isRoot;
                $scope.isRoot = AuthService.isRoot;
            }
        });

        DocumentsService.typeList({ admin: true }).then(function (data) {
            data.forEach(function (type) {
                if (type.parentId === 'OUTGOING') {
                    $scope.documentTypes[type.parentId].push(type);
                }
            });

        }).catch(function () {
            usSpinnerService.spin("root");
            toastr.error('', 'დაფიქსირდა შეცდომა');
        });

        DocumentsService.getDocumentAddresseeExternal().then(function (data) {
            data.forEach(function (addressee) {
                $scope.documentAuthors['PERSON'].push(addressee);

            });

        }).catch(function () {
            usSpinnerService.spin("root");
            toastr.error('', 'დაფიქსირდა შეცდომა');
        });

        $scope.deleteAddressee = function (id) {
            var el_index = _.findIndex($scope.addressees, function (addr) {
                return id === addr._id;
            });

            $scope.addressees.splice(el_index, 1);
        };

        $scope.send = function () {
            if (!$scope.type) toastr.error('', 'გთხოვთ მიუთითოთ დოკუმენტის ტიპი');
            else if (!$scope.receiverType) toastr.error('', 'გთხოვთ მიუთითოთ მიმღების ტიპი');
            else if (!$scope.receivers.length) toastr.error('', 'გთხოვთ მიუთითოთ მიმღები');
            else if (!$scope.comment) toastr.error('', 'გთხოვთ მიუთითოთ კომენტარი');
            else if (!$scope.text) toastr.error('', 'გთხოვთ მიუთითოთ ტექსტი');
            else if (!$scope.author) toastr.error('', 'გთხოვთ მიუთითოთ ტექსტი');
            else {
                usSpinnerService.spin("root");
                DocumentsService.registerOutgoing({
                    addresseeType: $scope.receiverType,
                    author: $scope.author.profile._id,

                    addressees: $scope.receivers.map(function (item) {
                        var addressee;
                        addressee = item;
                        addressee.info = { _id: item._id };

                        return addressee;
                    }),
                    receiverType: $scope.receiverType,
                    type: $scope.type,
                    text: $scope.text,
                    basisFiles: $scope.basisFiles,
                    basisDocs: $scope.basisDocs,
                    attachments: $scope.attachments,
                    comment: $scope.comment,



                    // topic: $scope.topic,
                    // senderType: $scope.senderType,

                    // senders: $scope.senders,


                    // documentNumber: $scope.documentNumber,
                    // documentDate: $scope.documentDate,
                    // documentFile: $scope.basisFiles[0]._id,
                    // sheetsNumber: $scope.sheetsNumber,
                    // deadline: $scope.deadLine
                }).then(function () {
                    usSpinnerService.stop("root");
                    toastr.success('', 'დოკუმენტი გაგზავნილია');
                    $rootScope.documentsCount();
                    $state.go('employee.documents.outgoing');
                }).catch(function () {
                    usSpinnerService.stop("root");
                    toastr.error('', 'დოკუმენტის გაგზავნისას დაფიქსირდა შეცდომა');
                })
            }
        };

        $scope.uploadAttachment = function (type, files) {
            usSpinnerService.spin("root");
            $scope.file = files[0];
            var fd = new FormData();
            if ($scope.file && $scope.file.name) {
                fd.append('file', $scope.file, $scope.file.name);
                $http.post('/documents/attachments', fd, {
                    headers: { 'Content-Type': undefined }
                }).then(function (response) {
                    if (type === 'basis') {
                        $scope.basisFiles.push(response.data);
                        $scope.fileName = response.data.name;
                    } else if (type === 'attachment') {
                        $scope.attachments.push(response.data);
                        $scope.fileName = response.data.name;
                    }
                    usSpinnerService.stop("root");
                })
            }
        };

        $scope.removeAttachment = function (type, file) {
            usSpinnerService.spin("root");
            if (type === 'basis' && !file.location) {
                for (var i in $scope.basisFiles) {
                    if (!$scope.basisFiles[i].location && file.name === $scope.basisFiles[i].name) {
                        $scope.basisFiles.splice(i, 1);
                        usSpinnerService.stop("root");
                    }
                }
            } else if (file.location) {
                DocumentsService.removeAttachment(file._id).then(function () {
                    var elementIndex;
                    if (type === 'basis') {
                        elementIndex = _.findIndex($scope.basisFiles, function (basisFile) {
                            return basisFile._id === file._id;
                        });
                        $scope.basisFiles.splice(elementIndex, 1);
                    }
                    if (type === 'attachment') {
                        elementIndex = _.findIndex($scope.attachments, function (attachmentFile) {
                            return attachmentFile._id === file._id;
                        });
                        $scope.attachments.splice(elementIndex, 1);
                    }
                    usSpinnerService.stop("root");
                })
            } else {
                usSpinnerService.stop("root");
            }
        };


        $scope.attachmentRequired = function () {
            for (var i in $scope.documentTypes) {
                var filtered = $scope.documentTypes[i].filter(function (el) {
                    return el._id === $scope.type
                });
                if (filtered.length > 0) {
                    return filtered[0].attachmentRequired || false;
                }
            }
            return false;
        }

        $scope.addReceiver = function () {
            $scope.receivers.push({
                name: $scope.receiver.name,
                id: $scope.receiver.id
            });
            $scope.receiver.name = '';
            $scope.receiver.id = '';
        };

        $scope.removeReceiver = function (sender) {
            $scope.receivers = $scope.receivers.filter(function (currentSender) {
                return sender.id !== currentSender.id;
            });
        };

        $scope.getReceivers = function (query) {
            if (query.length < 2) {
                return [];
            }
            return DocumentsService.sendersList({ query: query });
        };

        $scope.setReceiverNameAndId = function ($item) {
            $scope.receiver.id = $item.id;
            $scope.receiver.name = $item.name;
        }
        $scope.addToBasisDocs = function () {

            if (!$scope.basisDocs.find(a => a._id == $scope.basisDocNumber._id)) {
                $scope.basisDocs.push($scope.basisDocNumber);
            }

            $scope.basisDocNumber = null;
        };

        $scope.getDocumentNumbers = function (query) {
            if (query.length < 1) {
                return [];
            }
            return DocumentsService.getDocumentByUniqueNumber({
                uniqueNumber: query
            }).then(function (data) {
                return data;
            });
        };

        $scope.removeBasisDoc = function (basis) {
            $scope.basisDocs = $scope.basisDocs.filter(function (curr) {
                return curr !== basis;
            });
        };
    }]);
